import { render, staticRenderFns } from "./ManageCategoryCar.vue?vue&type=template&id=3322e4ad"
import script from "./ManageCategoryCar.vue?vue&type=script&lang=js"
export * from "./ManageCategoryCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports